import { render, staticRenderFns } from "./PartnersCommissions.vue?vue&type=template&id=4b815f46&scoped=true&"
import script from "./PartnersCommissions.vue?vue&type=script&lang=js&"
export * from "./PartnersCommissions.vue?vue&type=script&lang=js&"
import style0 from "./PartnersCommissions.vue?vue&type=style&index=0&id=4b815f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b815f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b815f46')) {
      api.createRecord('4b815f46', component.options)
    } else {
      api.reload('4b815f46', component.options)
    }
    module.hot.accept("./PartnersCommissions.vue?vue&type=template&id=4b815f46&scoped=true&", function () {
      api.rerender('4b815f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnersCommissions.vue"
export default component.exports